import FetchService from '../../../core/services/FetchService';
import { pickBy } from 'lodash';
import moment from 'moment';
import { extendObservable } from 'mobx';

export default class ContractDetailService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      contractId: null,
      contract: {},
    });
  }

  load = async (contractId) => {
    this.contractId = contractId;
    const contract = await this.fetch.fetch({ url: `/contracts/${this.contractId}`, apiVersion: 'v2' });
    const currentProducts = await this.fetch.fetch({
      apiVersion: 'v2',
      url: `/contracts/${this.contractId}/current-products`,
    });
    this.contract = {
      ...pickBy(contract, (value) => value !== null && value !== undefined),
      startsAt: moment(contract.startsAt).utc(),
      ...(contract.endsAt && { endsAt: moment(contract.endsAt).utc() }),
      products: currentProducts.map((product) => ({
        ...product,
        rowKey: product.id,
        ...(product.beginningOfTerm && { beginningOfTerm: moment(product.beginningOfTerm).add(3, 'hours') }),
      })),
    };
  };
}
